import { getURLType } from './getURLType';

export const hasMixedSources = (sources) => {
  let hasMixedSources = false;
  let firstURLType;
  let URLType;
  let i = 0;
  while (!hasMixedSources && i < sources.length) {
    const url = sources[i]?.url;
    if (url) {
      URLType = getURLType(url);

      if (!firstURLType) {
        firstURLType = URLType;
      }
      hasMixedSources = firstURLType !== URLType;
    }
    i++;
  }

  return hasMixedSources;
};
